import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  currentProject,
  projects,
  projectsForm,
  tasks,
  tasksForm,
} from "./Reducers";

export default combineReducers({
  tasks,
  tasksForm,
  projects,
  projectsForm,
  app,
  authorization,
  currentRoute,
  currentProject,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
